module.exports = __webpack_public_path__ + "fonts/Gotham-Medium.b70ecce5.woff2";